module.exports = __webpack_public_path__ + "img/multi-mode-3.34bddc40.png";